import { useCallback, useEffect, useRef } from 'react';
import { useShellComposerBridge } from '../contexts/ShellComposerBridgeContext';
/**
 * Build a typed {@link BridgeChannel} for `channel`. Only the channel's own
 * typed emitter writes it, so `subscribe` casts the bridge's `unknown` detail
 * to `T` safely.
 *
 * `useSubscribe` holds the listener in a ref so callers don't need to memoize
 * it — the latest closure runs on every event, and the subscription is set up
 * once per bridge instance.
 */
export function createBridgeChannel(channel) {
    var emit = function (bridge, payload) {
        return bridge.emit(channel, payload);
    };
    var subscribe = function (bridge, listener) {
        return bridge.subscribe(channel, function (detail) { return listener(detail); });
    };
    var useEmit = function () {
        var bridge = useShellComposerBridge();
        return useCallback(function (payload) { return emit(bridge, payload); }, [bridge]);
    };
    var useSubscribe = function (listener) {
        var bridge = useShellComposerBridge();
        var listenerRef = useRef(listener);
        listenerRef.current = listener;
        useEffect(function () { return subscribe(bridge, function (payload) { return listenerRef.current(payload); }); }, [bridge]);
    };
    return { channel: channel, emit: emit, subscribe: subscribe, useEmit: useEmit, useSubscribe: useSubscribe };
}
